// extracted by mini-css-extract-plugin
export default {"submitButton":"w_GIXguEExytRE5_GNZQ"};